import { Button, Grid, Typography } from "@mui/material";
import React from "react";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { useForm, useFormContext } from "react-hook-form";

export const OpenSurcharge: React.FC<any> = React.memo((props) => {
  const {
    register,
    control,
    setValue
  } = useFormContext();

 
  return (
   
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <Typography>Surcharge Percentage</Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
        <WSTextField
          label={""}
          {...register("surchargepercentage")}
          id="surchargepercentage"
          name="surchargepercentage"
          control={control}
          rules={{ required: false }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Typography>Surcharge Amount</Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
        <WSTextField
          label={""}
          {...register("surchargeamount")}
          id="surchargeamount"
          name="surchargeamount"
          control={control}
          rules={{ required: false }}
        />


      </Grid>

   
     
    </Grid>
  );
});
